import type { PropType } from 'virtual-vue';
import type { AvatarShape } from './avatar';

export const DEFAULT_AVATAR_SIZE = 100;
export const DEFAULT_AVATAR_SHAPE = 'circle';
export const DEFAULT_AVATAR_ALT = '头像';
export const DEFAULT_SHOW_DEFAULT_ON_LOAD = true;

/**
 * 组件的props
 * 基于方案设计文档生成
 */
export const props = {
  /**
   * 图片地址，用于图片头像
   */
  src: {
    type: String,
    default: '',
  },

  /**
   * 头像尺寸（高度等于宽度），单位：px
   * @default 100
   */
  size: {
    type: Number,
    default: DEFAULT_AVATAR_SIZE,
  },

  /**
   * 头像形状
   * @default 'circle'
   */
  shape: {
    type: String as PropType<AvatarShape>,
    default: DEFAULT_AVATAR_SHAPE,
    validator: (value: string) => ['circle', 'square'].includes(value),
  },

  /**
   * 图片替代文本（无障碍）
   * @default '头像'
   */
  alt: {
    type: String,
    default: DEFAULT_AVATAR_ALT,
  },

  /**
   * 是否在图片加载中时显示默认头像
   * @default true
   */
  showDefaultOnLoad: {
    type: Boolean,
    default: DEFAULT_SHOW_DEFAULT_ON_LOAD,
  },
};

